import Echo from '@ably/laravel-echo';

import { WebsocketService } from '../websockets';

type PresenceChannel = ReturnType<Echo['join']>;

export class PrivateEchoPresenceWebsocketService extends WebsocketService<PresenceChannel> {
  constructor() {
    super({
      channelApi: {
        connect: (echo, channelName) => echo.join(channelName),
        leave: (echo, channelName) => echo.leave(channelName),
        listen: (channel, eventName, handler) => {
          channel.listen(eventName, handler);
        },
        stopListening: (channel, eventName, handler) => {
          channel.stopListening(eventName, handler);
        },
      },
    });
  }
}
